import script from "./InputCard.vue?vue&type=script&lang=ts&setup=true"
export * from "./InputCard.vue?vue&type=script&lang=ts&setup=true"

import "./InputCard.vue?vue&type=style&index=0&id=4c3891c0&lang=less"

const __exports__ = script;

export default __exports__